import React, {Component} from 'react';

class EBook extends Component {
    constructor(props) {
        super(props);
        this.input = null;
    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    confirm() {
        let valid = true;
        this.input.classList.remove('error');

        if (!this.validateEmail(this.input.value)) {
            valid = false;
            this.input.classList.add('error');
        }

        if (valid) {
	        const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;
            let {type} = this.props;
            const data = new FormData();
            data.append('email', this.input.value);
            data.append('type', type);

            fetch('/api/ebook', {
	            headers: {
		            "Accept": "application/json",
		            "X-CSRF-Token": csrfToken
	            },
                'method': 'POST',
                body: data
            }).then(result => {
                return result.json();
            }).then(data => {

                if (data.status === 200) {
                    alert('Ďakujeme, na email sme Vám poslali E-book!');
                    this.input.value = '';

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "ebook-success-submit",
                        value: type
                    });

                } else {
                    alert('Niečo sa pokazilo, prosím skúste nás kontaktovať. Ďakujeme!');
                }
            })
        }
    }

    render() {
        let {type, content} = this.props;
        const types = {
            'tipy': {
                'title': "55 tipov ako ušetriť peniaze za energie",
                'img': 'e-book-55-tipov.png',
	            'btn': 'Stiahnúť e-book'
            },
            'termo': {
                'title': "10 problémov, pri ktorých vám pomôže termovízia",
                'img': 'e-book-termovizia.png',
	            'btn': 'Stiahnúť e-book'
            },
            'certifikat': {
                'title': "9 vecí, ktoré by ste mali vedieť o energetickom certifikáte",
                'img': 'e-book.png',
	            'btn': 'Stiahnúť e-book'
            },
            'rady': {
                'title': "12 rád ako nepokaziť rekuperačný systém",
                'img': 'e-book-12-rad.png',
	            'btn': 'Stiahnúť e-book'
            },
	        'dom': {
                'title': "Pomôcka - výstavba domu A0, jednoducho a bez zbytočných nákladov",
                'img': 'e-book-dom.png',
		        'btn': 'Stiahnúť e-book'
            },
	        'planObnovy': {
                'title': "Návod na získanie dotácie. Plán obnovy starších rodinných domov",
                'img': 'plan-obnovy.jpg',
		        'btn': 'Stiahnúť návod'
            },

        }
        if (content === 'blog') {
            return (
                <section className="e-book-blog">
                    <img src={"/images/" + types[type].img} alt={types[type].title} />
                    <div className="content">
                        <h2>
                            <small>E-book zdarma</small>
                            {types[type].title}
                        </h2>
                        <input ref={ref => (this.input = ref)} type="text" placeholder="Zadajte svoj e-mail " />
                        <button onClick={() => this.confirm()} className="btn">{types[type].btn}</button>

                        <div className="form-group">
                            <label> Odoslaním formulára vyhlasujete, že ste sa oboznámili <br/>s <a
                                href="/storage/ochrana-osobnych-udajov.pdf" target="_blank">informáciami o spracúvaní
                                osobných údajov</a>.</label>
                        </div>


                    </div>
                </section>
            );
        } else {
            return (
                <section className="e-book">
                    <div className="container">
                        <div className="content">
                            <h2>
                                <small>E-book zdarma</small>
                                {types[type].title}
                            </h2>
                            <input ref={ref => (this.input = ref)} type="text" placeholder="Zadajte svoj e-mail" />
                            <button type="submit" onClick={() => this.confirm()} className="btn">{types[type].btn}</button>
                            <div className="form-group">
                                <label> Odoslaním formulára vyhlasujete, že ste sa oboznámili <br/>s <a href="/storage/ochrana-osobnych-udajov.pdf" target="_blank">informáciami o spracúvaní osobných údajov</a>.</label>
                            </div>
                        </div>
                        <div className="img-box">
                            <img src={"/images/" + types[type].img} alt={types[type].title} />
                        </div>
                    </div>
                </section>
            );
        }
    }
}

export default EBook;